import { render, staticRenderFns } from "./OaoTextWithArrowLink.vue?vue&type=template&id=66dfe6da&scoped=true"
import script from "./OaoTextWithArrowLink.vue?vue&type=script&lang=js"
export * from "./OaoTextWithArrowLink.vue?vue&type=script&lang=js"
import style0 from "./OaoTextWithArrowLink.vue?vue&type=style&index=0&id=66dfe6da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dfe6da",
  null
  
)

export default component.exports